import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeAgo',
  standalone: true,
  pure: true,
})
export class TimeAgoPipe implements PipeTransform {
  transform(value: string | Date): string {
    if (!value) return '-';

    const now = Date.now();
    const timeValue = new Date(value);
    const diffMinutes = Math.floor((now - timeValue.getTime()) / 1000 / 60);

    if (diffMinutes < 1) return '방금 전';
    if (diffMinutes < 60) return `${diffMinutes}분 전`;

    const diffHours = Math.floor(diffMinutes / 60);
    if (diffHours < 24) return `${diffHours}시간 전`;

    return new DatePipe('ko').transform(timeValue, 'y-MM-dd') || '';
  }
}
